<template>
	<li v-if="isWMAEnabledPartner" class="nav-link" role="none">
		<button
			:class="officeOpenInfo.active ? 'office-open' : 'office-closed'"
			@click.prevent="onScheduleClick"
		>
			<span>{{ officeOpenInfo.indicator }}</span>
		</button>
	</li>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'

/** Matches NewSetting SECTION_IDS.OFFICE_HOURS */
const SETTINGS_OFFICE_HOURS_SECTION = 'officeHours'

export default {
	computed: {
		isWMAEnabledPartner() {
			return this.partner?.wma_enabled && this.officeOpenInfo.visible
		},

		...mapGetters({
			partner: 'partners/active',
			access: 'auth/hasOfficeManagerAccess',
			clarusAppType: 'partners/clarusAppType',
		}),
		...mapState('settings', {
			officeOpenInfo: state => state.officeOpenInfo,
		}),
	},

	methods: {
		async onScheduleClick() {
			if (!this.clarusAppType) {
				return this.$alert.error(
					'Please contact your system administrator.'
				)
			}

			if (!this.access) {
				return
			}

			const target = {
				name: 'app.settings',
				params: {
					partner: this.$route.params.partner,
					section: SETTINGS_OFFICE_HOURS_SECTION,
				},
			}

			if (this.$route.name === 'app.settings') {
				if (
					this.$route.params.section !== SETTINGS_OFFICE_HOURS_SECTION
				) {
					await this.$router.replace(target)
				}
				return
			}

			await this.$router.push(target)
		},

		...mapActions('settings', {
			getOfficestatus: 'getOfficestatus',
		}),
	},

	name: 'OfficeStatus',

	watch: {
		'partner.id': {
			handler(newPartnerId, oldPartnerId) {
				if (newPartnerId !== oldPartnerId) {
					this.getOfficestatus()
				}
			},
			immediate: true,
		},
	},

	created() {
		this.getOfficestatus()
	},

	data() {
		return {
			intervalId: null,
		}
	},
}
</script>
